<template>
<div >

    
    <v-dialog
      v-model="dialog"
      width="500"
    >
    
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="editar == true" small class="success" v-bind="attrs" v-on="on" >
            <v-icon small>fa fa-edit</v-icon>
        </v-btn>
        <v-btn v-if="editar == false" class="success" v-bind="attrs" v-on="on" >
            <v-icon left>mdi-plus</v-icon>
            <span >Nova função</span>
        </v-btn>

      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Nova função/atividade
        </v-card-title>

        <v-div >
           <v-form class="pa-5" ref="form">
               <v-layout row>

               </v-layout>
               <v-text-field :rules="inputRules"
               v-model="funcao.descricao" prepend-icon="fa fa-user"
               label="Nome da atividade" >

               </v-text-field>

              
              <vuetify-money
              v-model="funcao.preco"
              label="Valor do serviço"
              placeholder="00.00"
              v-bind:options="options"
                > </vuetify-money>

                <v-select
                prepend-icon="fa fa-hourglass-start"
                :items="horarios"
                v-model="funcao.tempo"
                label="Tempo do serviço"
                ></v-select>
           </v-form>
        </v-div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="this.editar == false" color="primary" text @click="criarNovaFuncao">
            Criar
          </v-btn>
          <v-btn v-if="this.editar == true" color="primary" text @click="atualizarFuncao">
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {refFuncoes} from '@/firebaseConfig'
//import EventBus from '../../../bus.js';

    export default {
        props: ['acaoEditar', 'funcaoPassada'],
        data(){
            return {
                editar: this.acaoEditar,
                 dbRef: refFuncoes,
                 dialog: false,
                  date: null,
                    menu: false,
                 funcao: {
                     descricao: '', 
                     preco: '',
                     id: '',
                     tempo: '',
                 },
                 
                 horarios: [
                     "10m","20m","30m","40m","50m","60m","60m","70m","80m","90m","100m","110m","120m"
                    //  "30m","60m","90m","120m","150m","180m",
                     //"40m","45m","50m","55m","60m","90m",
                 ],
                 inputRules: [
                    v => v.length >= 3 || "Tamanho mínimo é 3 caractéres"
                ],
                options: {
                  locale: "pt-BR",
                  prefix: "R$",
                  suffix: "",
                  length: 11,
                  precision: 2
              },

            }
        },
      
    methods: {
     
      atualizarFuncao(){
            if(this.$refs.form.validate()){
                console.log("atualizar")
                console.log(this.funcao)
                
                this.dbRef.doc(this.funcao.id).update(this.funcao).then(() => {
                  this.$toasted.global.defaultSuccess("Atualizado com sucesso!");
                    //this.Funcoes.carregar();
                    
                });
                this.$refs.form.reset()
            }

            this.dialog = false;
            this.$emit('recarregarLista');

            //this._vm.$forceUpdate();


      },
      criarNovaFuncao(){
            if(this.$refs.form.validate()){
                console.log("registrar")
                
                this.dbRef.add(this.funcao).then(ref => {
                    console.log(ref);
                    //this.barbeiro.id = ref.id;
                    
                    //ref.set(this.barbeiro);
                    //this.dbRef.doc(ref.id).update(this.barbeiro);
                    ref.update({id:ref.id });
                    this.$toasted.global.defaultSuccess("Criado com sucesso!");
                    //this.Funcoes.carregar();
                    this.$emit('recarregarLista');

                })
                this.$refs.form.reset()
            }

            this.dialog = false

      },
      ajustarPagina(){
        console.log("created!")
       console.log(this.editar)
       if(this.editar == true){
         this.funcao = this.funcaoPassada;
       }
      }
    },
    created() {
      this.ajustarPagina()
    }
    }
</script>

<style lang="scss" scoped>

</style>